query competitionSgpConfigurationByCompetitionId($competitionId: UUID!) {
  competition: competitionSgpConfigurationByCompetitionId(
    competitionId: $competitionId
  ) {
    workersPerEvent
    competitionId
  }
}
